import UserInterface from '@/interfaces/User';
import axios from 'axios';
import Vue from 'vue';

class AuthService extends Vue{

  login(user: UserInterface) {
    return axios.post('auth/login', user );
  }

  refreshToken(rToken: string){
    return axios.post('auth/refreshlogin', {refreshToken: rToken});
  }
}

export default new AuthService();

export function AuthUpdate(requestHeaders: any){
  //do something... like... update its token?
}
